const galleryImages = [
  {
    src: "/images/food/mixing-tanks.webp",
    alt: "Dairy Processing Tanks",
    label: "Mixing & Blending Tanks",
  },
  {
    src: "/images/food/conveyor.webp",
    alt: "Meat Conveyor Installation",
    label: "Food Conveyor Line",
  },
  {
    src: "/images/food/silos.webp",
    alt: "Grain Storage Silos",
    label: "Stainless Storage Silos",
  },
  {
    src: "/images/food/pasteuriser.webp",
    alt: "Beverage Pasteurisation",
    label: "Plate Heat Exchanger Pasteuriser",
  },
  {
    src: "/images/food/cutting-tables.webp",
    alt: "Bakery Processing Tables",
    label: "Processing & Cutting Table",
  },
  {
    src: "/images/food/filling.webp",
    alt: "Fish Processing Station",
    label: "Filling & Packaging Line",
  },
];

export default function FoodGallery() {
  return (
    <section id="gallery" className="py-24 bg-gray-50">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 mb-14">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Our Work</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            Project Showcase
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            A selection of food processing installations completed by ISMAN Engineering
            across Kenya — from large-scale dairy plants to specialist abattoirs and bakeries.
          </p>
        </div>
      </div>

      {/* Masonry Grid */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {galleryImages.map((img, i) => (
            <div
              key={img.alt}
              className={`relative overflow-hidden rounded-lg group ${i === 0 || i === 5 ? "sm:col-span-2 lg:col-span-1" : ""}`}
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                <p className="text-white text-xs font-semibold uppercase tracking-wide">{img.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
